import { createApp } from "vue"
import DonationForm from "./DonationForm.vue"

const app = createApp(DonationForm)
app.mount("#donation-app")
